import { render, staticRenderFns } from "./ActivityLogPage.vue?vue&type=template&id=bb009a20&"
import script from "./ActivityLogPage.vue?vue&type=script&lang=js&"
export * from "./ActivityLogPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb009a20')) {
      api.createRecord('bb009a20', component.options)
    } else {
      api.reload('bb009a20', component.options)
    }
    module.hot.accept("./ActivityLogPage.vue?vue&type=template&id=bb009a20&", function () {
      api.rerender('bb009a20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ActivityLogPage.vue"
export default component.exports